import SkillsAnimation from './../utils/skills-animation';

const About = () => {
  SkillsAnimation();

  return (
    <section className="about">
      <div className="about__info">
        <h2>Me, Myself & I</h2>
        <p>
        Iradukunda Irenee is a software developer based in Rwanda, He is a professional web developer with over 4 years of experience in the industry. He has a strong background in developing web applications using different technologies such as javascript, React, Node.js, and python. He is passionate about building user-friendly and efficient web solutions that can help people and businesses achieve their goals. He is also skilled in database management and optimization. He is a proactive, self-motivated, and results-driven developer who is always looking for new ways to improve his skills and deliver value to his clients and employer.
        </p>
      </div>
      <div className="about__skills">
        <div id="tag"></div>
      </div>
    </section>
  );
};

export default About;
